import { css } from '@emotion/react';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('multiSelectGroup', [
  'divider',
  'label',
  'list',
]);

const styles = css`
  .${classes.divider} {
    margin: var(--cds-spacing-100) 0;
  }

  .${classes.label} {
    padding: var(--cds-spacing-100);
  }

  .${classes.list} {
    list-style: none;
    padding: 0 var(--cds-spacing-25);
  }
`;

export default styles;
